export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: 'What materials does Shear Geometry cover?',
    answer:
      'The published guidance covers 6061-T6 aluminum, copper and soft aluminum alloys, plus titanium with DR80 inserts. Call technical assistance at 650-224-7511 to confirm fit for a specific alloy and application.',
  },
  {
    question: 'Can I use these tools on a manual lathe?',
    answer:
      'No. The published instructions specify CNC lathes only and say the tooling is not intended for manual lathes.',
  },
  {
    question: 'Which holder sizes are published?',
    answer:
      'The published system includes the 1-inch SALXR 16-3D and 3/4-inch SALXR 12-3B holders.',
  },
  {
    question: 'What comes in a starter kit?',
    answer:
      'The 1-inch and 3/4-inch starter kits each include the matching holder, 10 APGX 331R inserts, a Torx driver and extra screws. Call sales to confirm fit for your machine.',
  },
  {
    question: 'How are inserts packaged?',
    answer:
      'Inserts are sold in full boxes of 10. Call 800-397-7745 for pricing and availability.',
  },
  {
    question: 'When should I consider a chipbreaker insert?',
    answer:
      'The published -30R chipbreaker range uses a lower feed starting range than the roughing insert and is intended for applications where tighter chip control is the priority. Final selection depends on the material and setup.',
  },
  {
    question: 'What information should I send for product guidance?',
    answer:
      'Send the material and condition, machine model and horsepower, workholding, holder size, target depth of cut and feed, application goal, and expected quantity.',
  },
  {
    question: 'How do I confirm current availability?',
    answer:
      'Call sales at 800-397-7745 or email sales@sheargeometry.com. Pricing, availability and ordering are handled directly; there is no online purchasing.',
  },
]
